import MUSTACHE from 'mustache';

export default class ContentHandler {

  constructor(settings={}) {
    let _this = this;
    this.connections={};
    this.dataset={};
    this.hooks = null;
    this.image_path = '';
    this.app_path = '';
    this.handler={};
    this._settings={};
    this._match={};
    this.handler.mustache = MUSTACHE;
    if(!(typeof this.handler.mustache === 'object'))
    {
      this.handler.mustache={};
    }
    this._log = function(type,source,message,data='')
    {
      let _message = 'js_helper/ContentHandler::'+source+'- '+message;
      switch(type)
      {
        case "debug":
          console.debug(_message,data);
          break;
        case "warning":
          console.warn(_message,data);
        case "info":
          console.info(_message,data);
          break;
        case "error":
          console.error(_message,data);
          break;
        default:
            console.log(_message,data);
      }
    };
    this._helpers = {
      'has':function(...params){
        return false;
      },
      'run':function(...params){
        return false;
      },
      'list':function()
      {
        return [];
      }
    };

    if(typeof settings === 'object' && settings !== null)
    {
      if('_log' in settings && typeof settings._log === 'function')
      {
        this._log = function(type,source,message,data=''){
          settings._log(type,'ContentHandler::'+source,message,data);
        }
      }
      if('helpers' in settings && typeof settings.helpers === 'object')
      {
        this._helpers=settings.helpers;
      }

      if('options' in settings)
      {
        for(let _an_option in settings.options)
        {
          if(_an_option.startsWith('='))
          {
            let an_option=_an_option.substring(1,_an_option.length);
            let match_type = an_option.split('|');
            if(match_type.length==2)
            {
              switch(match_type[0])
              {
                case "url_to_tax":
                  if(!('url_to_tax' in this._match))
                  {
                    this._match['url_to_tax']={'values':{},'function':function(){
                      let current_url=window.location.toString();
                      let result=[];
                      for(let a_path in _this._match['url_to_tax'].values)
                      {
                        if(current_url.includes(a_path))
                        {
                          result.push(_this._match['url_to_tax'].values[a_path]);
                        }
                      }
                      return result.join(',');
                    }};
                  }
                  this._match['url_to_tax'].values[match_type[1]]=settings.options[_an_option];
                  break;
                case "tax_to_tax":
                  if(!('tax_to_tax' in this._match))
                  {
                    this._match['tax_to_tax']={'values':{},'function':function(){
                      let result=[];
                      let env_context = _this._helpers.run('env','getContext',[false,function(){return {}}]);
                      let taxonomies_ids = _this._getDataValue(env_context,'taxonomies.ids',false);
                      if(taxonomies_ids)
                      {
                        if(!Array.isArray(taxonomies_ids))
                        {
                          taxonomies_ids=[taxonomies_ids];
                        }
                        for(let a_path in _this._match['tax_to_tax'].values)
                        {
                          for(let anid of taxonomies_ids)
                          {
                            if(""+a_path==""+anid)
                            {
                              result.push(_this._match['tax_to_tax'].values[a_path]);
                            }
                          }
                        }
                      }
                      return result.join(',');
                    }};
                  }
                  this._match['tax_to_tax'].values[match_type[1]]=settings.options[_an_option];
                  break;
                default:
                  break;
              }
            }
          }
          else
          {
            this._settings[_an_option]=settings.options[_an_option];
          }
        }
      }
    }
  }

  _getSetting(name,_default=null)
  {
    if(typeof this._settings === 'object' && name in this._settings)
    {
      return this._settings[name];
    }
    return _default;
  }
  async init(hooks,user)
  {
    if(typeof user === 'object' && user !== null && ('token' in user))
    {
      this.user = user;
    }
    else
    {
      console.error('user passed is not a UserHandler!',user.constructor);
    }
    this.hooks = hooks;
    return true;
  }

  format_date(timestamp, format='default',show_time=false)
  {
    var date = null;

    var return_date = '';

    const calculateTimimg = function (d){
      let months = 0, years = 0, days = 0, weeks = 0, total = d;
      while(d){
          if(d >= 365){
            years++;
            d -= 365;
          }else if(d >= 30){
            months++;
            d -= 30;
          }else if(d >= 7){
            weeks++;
            d -= 7;
          }else{
            days++;
            d--;
          }
      };
      return {
          years, months, weeks, days, total
      };
    };

    switch(timestamp)
    {
      case "now":
      case "today":
         date = new Date();
         break;
      case "yesterday":
        date = new Date();
        date.setDate(date.getDate() - 1);
        break;
      case "tomorrow":
        date = new Date();
        date.setDate(date.getDate() + 1);
        break;
      default:
        if(!isNaN(timestamp))
        {
          date = new Date(timestamp * 1000);
        }
        else
        {
          // Assume mysql timestamp
          /**
          console.debug(timestamp);
          let t = timestamp.split(/[- :]/);
          console.debug(t);
          date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
          console.debug(date);
          */
          date = new Date(timestamp);
        }
        break;
    }

    switch(format)
    {
      case "timestamp_y-m-d":
          return_date = new Date(date.getFullYear()+"-"+(("0" + (date.getMonth() + 1)).slice(-2))+"-"+(("0" + (date.getDate())).slice(-2))).getTime()/1000;
          break;
      case "Y-m-d":
          return_date = date.getFullYear()+"-"+(("0" + (date.getMonth() + 1)).slice(-2))+"-"+(("0" + (date.getDate())).slice(-2));
          break;
      case "since":
          //calculate time difference
         var time_difference = new Date().getTime() - date.getTime();

         //calculate days difference by dividing total milliseconds in a day
         let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

         let _return_date = [];

         if(('years' in dwmy) && dwmy.years>0)
         {
           _return_date.push(dwmy.years+' year'+(dwmy.years == 1?'':'s'));
         }

         if(('months' in dwmy) && dwmy.months>0)
         {
           _return_date.push(dwmy.months+' month'+(dwmy.months == 1?'':'s'));
         }

         if(('weeks' in dwmy) && dwmy.weeks>0)
         {
           _return_date.push(dwmy.weeks+' week'+(dwmy.weeks == 1?'':'s'));
         }

         if(('days' in dwmy) && dwmy.days>0)
         {
           _return_date.push(dwmy.days+' day'+(dwmy.days == 1?'':'s'));
         }

         return_date = dwmy;

         return_date.string = _return_date.join(", ");

         break;
      default:
        const nth = function(d) {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1:  return "st";
            case 2:  return "nd";
            case 3:  return "rd";
            default: return "th";
          }
        }

        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();

        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();

        // Will display time in YYYY/MM/DD 10:30:23 format
        if(show_time)
        {
          return_date = day+''+nth(day)+' '+month+' '+year+' at '+hours + ':' + minutes.substr(-2);
        }
        else
        {
          return_date = day+''+nth(day)+' '+month+' '+year;
        }
    }

    return return_date;
  }

  _processMoustache(target,data={})
  {
    let result = '';
    let _this = this;
    let function___processMoustache = function(template,data={})
    {
      if(('::timestamp_to_date' in data))
      {
        data.date = function(){
          return _this.format_date(data['::timestamp_to_date'],'Y-m-d');
        };
      }
      data.today = function(){
        return _this.format_date('now','Y-m-d');
      };
      if(!('date' in data))
      {
        data.date = function(){
          return _this.format_date('now','Y-m-d');
        };
      }
      data.yesterday = function(){
        return _this.format_date('yesterday','Y-m-d');
      };
      data.yesterday_timestamp = function(){
        return _this.format_date('yesterday','timestamp_y-m-d');
      };
      data.today_timestamp = function(){
        return _this.format_date('now','timestamp_y-m-d');
      };
      data.tomorrow = function(){
        return _this.format_date('tomorrow','Y-m-d');
      };

      let env_context = _this._helpers.run('env','getContext',[false,function(){return {}}]);
      if((typeof env_context === 'object') && env_context !== null)
      {
        data['env']={};
        data['env']['context']=env_context;
      }
      if(typeof _this._match === 'object')
      {
        for(let a_match in _this._match)
        {
          if(typeof _this._match[a_match] === 'object')
          {
            if('function' in _this._match[a_match])
            {
              data[a_match]=_this._match[a_match].function();
            }
            else if('values' in _this._match[a_match])
            {
              if(Array.isArray(_this._match[a_match].values))
              {
                data[a_match]=_this._match[a_match].values.join(',');
              }
              else
              {
                data[a_match]=_this._match[a_match].values;
              }
            }
            else
            {
              data[a_match]='';
            }
          }
          else
          {
            data[a_match]=_this._match[a_match];
          }
        }
      }
      //console.error('@@',data,env_context);
      return _this.handler.mustache.render(template, data);
    }

    if(Array.isArray(target))
    {
      result=[];
      for(let i=0;i<target.length;i++)
      {
        result[i]=function___processMoustache(target,data);
      }
    }
    else if(typeof string == 'object')
    {
      result={};
      for(let atarget in target)
      {
        result[atarget]=function___processMoustache(target[atarget],data);
      }
    }
    else
    {
      result=function___processMoustache(target,data);
    }
    return result;
  }

  _processHash(target,data={},mode=true)
  {
    let result = '';
    let _this = this;
    let function___processHash = function(this_url,data={},mode=true)
    {
      let hash = decodeURIComponent(this_url);
      if(hash.length > 0 && hash.includes('#'))
      {
        let _hashes = hash.split('#').filter(function(i) { return i;});

        if(mode==='object')
        {
          return _this._processQuery((_hashes.length>1?_hashes[1]:_hashes[0]),data,'object');
        }
        else
        {
          return _hashes[0]+'#'+_this._processQuery(_hashes[1],data);
        }
      }
      return {};
    }

    if(Array.isArray(target))
    {
      result=[];
      for(let i=0;i<target.length;i++)
      {
        result[i]=function___processHash(target,data,mode);
      }
    }
    else if(typeof string == 'object')
    {
      result={};
      for(let atarget in target)
      {
        result[atarget]=function___processHash(target[atarget],data,mode);
      }
    }
    else
    {
      result=function___processHash(target,data,mode);
    }
    return result;
  }

  _processQuery(query,params={},mode=true)
  {
    let _this = this;
    const getQueryParams = function (query,_params={},mode=false)
    {
      let params = {};
      if(typeof query === 'string')
      {
        if(query.includes('?'))
        {
          query=query.substring(query.indexOf('?')+1);
        }
        query = _this._processMoustache(query);
        new URLSearchParams(query).forEach((value, key) => {
          let decodedKey = decodeURIComponent(key);
          let decodedValue = decodeURIComponent(value);

          //if(mode == "process")
          //{
            switch(decodedValue)
            {
              case "{{today}}":
                decodedValue = _this.format_date('now','Y-m-d');
                break;
              case "{{yesterday}}":
                decodedValue = _this.format_date('yesterday','Y-m-d');
                break;
              case "{{yesterday_timestamp}}":
                decodedValue = _this.format_date('yesterday','timestamp_y-m-d');
                break;
              case "{{today_timestamp}}":
                decodedValue = _this.format_date('now','timestamp_y-m-d');
                break;
              case "{{tomorrow}}":
                decodedValue = _this.format_date('tomorrow','Y-m-d');
                break;
              default:
                break;
            }
          //}

          // This key is part of an array
          if (decodedKey.endsWith("[]")) {
            decodedKey = decodedKey.replace("[]", "");
            params[decodedKey] || (params[decodedKey] = []);
            params[decodedKey].push(decodedValue);
            // Just a regular parameter
          } else {
            params[decodedKey] = decodedValue;
          }
        });
        if(mode=='diff')
        {
          let diff={};
          for(let _param_key in _params)
          {
            if(_param_key in params)
            {
              if(params[_param_key] == _params[_param_key])
              {
                if(!('same' in diff))
                {
                  diff.same={};
                }
                diff.same[_param_key]=params[_param_key];
              }
              else
              {
                if(!('changed' in diff))
                {
                  diff.changed={};
                }
                diff.changed[_param_key]={};
                diff.changed[_param_key].from=params[_param_key];
                diff.changed[_param_key].to=_params[_param_key];
              }
            }
            else
            {
              if(!('missing' in diff))
              {
                diff.missing={};
              }
              diff.missing[_param_key]=_params[_param_key];
            }
          }
          return diff;
        }
        else
        {
          // Update with _params
          for(let _param_key in _params)
          {
              params[_param_key] = _params[_param_key];
          }

          if(mode=='cleanse')
          {
            // Remove missing
            for(let param_key in params)
            {
              if(!(param_key in _params))
              {
                delete params[param_key];
              }
            }
          }
        }
      }
      return params;
    };
    if(mode=='diff')
    {
      if(typeof params !== 'object')
      {
        params =getQueryParams(params);
      }
      return getQueryParams(query,params,mode)
    }
    else if(mode=='object')
    {
      return getQueryParams(query,params,mode);
    }
    else
    {
      let thisQueryString=[];
      let url_params = getQueryParams(query,params,mode);
      for(let aUrl_paramsKey in url_params)
      {
        if(Array.isArray(url_params[aUrl_paramsKey]))
        {
          for(let i=0;i<url_params[aUrl_paramsKey].length;i++)
            {
              thisQueryString.push(aUrl_paramsKey+'[]='+url_params[aUrl_paramsKey][i]);
            }
        }
        else
        {
          thisQueryString.push(aUrl_paramsKey+'='+url_params[aUrl_paramsKey]);
        }
      };
      return thisQueryString.join('&');
      //let url_params = new URLSearchParams(getQueryParams(query,params,mode));
      //return url_params.toString();
    }
  }

  _processData(data,params={},mode='ommit')
  {
    let _this = this;
    let function___processData = function(data,params)
    {
      let _function__matchValues=function(type,field_value,data_value){
        if(!Array.isArray(data_value))
        {
          data_value=[data_value];
        }
        for(let adata_value of data_value)
        {
          switch(type)
          {
            case "not":
              if(adata_value!==field_value)
              {
                return true;
              }
              break;
            default:
              if(typeof field_value === 'object' &&  typeof adata_value === 'object')
              {
                if(adata_value==field_value)
                {
                  return true;
                }
              }
              else if(""+adata_value==""+field_value)
              {
                return true;
              }

              break;
          }
        }
        return false;
      };
      let _function__recursiveTest=function(data,field,field_value){
          //console.error('#_processData._function__recursiveTest...',data,field,field_value);
          if(!Array.isArray(field))
          {
              field=field.split('.');
          }
          let thisField=field[0];
          if(thisField in data)
          {
             //console.error('#_processData@1',thisField);
              if(field.length==1)
              {
                //console.error('#_processData@2',field);
                if(!(typeof field_value === 'object'))
                {
                  let _field_value=field_value;
                  field_value={};
                  field_value.eq=_field_value;
                }
                //console.error('#_processData@3',field_value);
                for(let _a_field_value_type in field_value)
                {
                  let explode_values=field_value[_a_field_value_type];
                  if(!Array.isArray(explode_values))
                  {
                    explode_values = explode_values.split(';');
                  }
                  if(explode_values.length==1)
                  {
                    explode_values = explode_values[0].split(',');
                  }
                  //console.error('#_processData@4',explode_values);
                  let success_count = 0;
                  _this._log('debug','_processData','_function__recursiveTest',[_a_field_value_type,explode_values,data[thisField]]);
                  for(let i=0;i<explode_values.length;i++)
                  {
                    if(_function__matchValues(_a_field_value_type,explode_values[i],data[thisField]))
                    {
                      _this._log('debug','_processData','Success _function__matchValues',[_a_field_value_type,explode_values[i],data[thisField]]);
                      success_count++
                    }
                    else
                    {
                      _this._log('debug','_processData','Failed _function__matchValues',[_a_field_value_type,explode_values[i],data[thisField]]);
                    }
                  }
                  if(success_count>0)
                  {
                    return true;
                  }
                  else
                  {
                    return false;
                  }
                }
              }
              else
              {
                  field.shift();
                  return _function__recursiveTest(data[thisField],field,field_value);
              }
          }
          throw 'Unknown';
      };

      let count = 0;
      let offset = (('_[offset]' in params)?params['_[offset]']:0);
      let limit = (('_[limit]' in params)?params['_[limit]']:0);


      let continue_processing = true;
      for(let i=0;i<data.length;i++)
      {
        if(!continue_processing)
        {
          break;
        }
        let is_deleted=false;
        for(let a_param in params)
        {
          if(!a_param.startsWith('_') && !is_deleted)
          {
            try
            {
              _this._log('debug','_processData','function___processData',{'data[i]':data[i],'a_param':a_param,'params[a_param]':params[a_param]});
              if(!_function__recursiveTest(data[i],a_param,params[a_param]))
              {
                throw 'no-match';
              }
            }
            catch(ex)
            {
              if(mode === 'ommit')
              {
                //console.error('#function___processData::delete',JSON.stringify(data[i]),params);
                delete data[i];
                is_deleted=true;
                break;
              }
              else
              {
                //console.error('#function___processData::keep',JSON.stringify(data[i]),params);
              }
            }
          }
        }
        if(!is_deleted)
        {
          count++;
          if(offset>0 && count<offset)
          {
            delete data[i];
          }
          if(limit>0 && count>limit)
          {
            continue_processing=false;
          }
        }
      }
      return data.filter(function(i) { return i;});
    }

    if(Array.isArray(data))
    {
      data=function___processData(data,params);
    }
    else
    {
      data=function___processData([data],params);
      if(data.length>0)
      {
        data=data[0];
      }
    }

    return data;
  }

  _getDataValue(data,key,default_value=null)
  {
    let _function__recursiveGet=function(data,field){
          //console.error('_getDataValue._function__recursiveGet...',data,field);
          if(!Array.isArray(field))
          {
              field=field.split('.');
          }
          let thisField=field[0];
          if(thisField in data)
          {
              if(field.length==1)
              {
                //console.error('_getDataValue._function__recursiveGet... Found '+thisField,data[thisField]);
                return data[thisField];
              }
              else
              {
                  field.shift();
                  //console.error('_getDataValue._function__recursiveGet... Found '+thisField+' recursing',field,data[thisField]);
                  return _function__recursiveGet(data[thisField],field);
              }
          }
          throw 'Unknown';
    };
    try
    {
      return _function__recursiveGet(data,key);
    }
    catch(e)
    {
      return default_value;
    }
  }

  _getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let myCookie = c.substring(name.length, c.length);
        try
        {
          JSON.parse(myCookie);
          return myCookie;
        }
        catch (e)
        {
          return myCookie;
        }
      }
    }
    return "";
  }

  async addConnectionAsync(alias,url,options=false,auth=false)
  {
    let _this = this;

    if(!(alias in this.connections))
    {
      if(!(typeof options === 'object'))
      {
        try
        {
          options = JSON.parse(JSON.stringify(options));
        }
        catch(ex)
        {
          this._log('warning','addConnection','Alias: '+alias+' options doesnt seem to be JSON');
        }

        if(!(typeof options === 'object') || object === null)
        {
          options={};
        }
      }
      if(!(typeof auth === 'object'))
      {
        try
        {
          auth = JSON.parse(JSON.stringify(auth));
        }
        catch(ex)
        {
          this._log('warning','addConnection','Alias: '+alias+' auth doesnt seem to be JSON');
        }
        if(!(typeof auth === 'object') || auth === null)
        {
          auth={};
        }
      }

      if(!('header' in options))
      {
        options.header = {};
      }

      let user_object = false;
      if(('method' in auth) && ('target' in auth))
      {
        let user_token = false;
        switch(auth.method)
        {
          case "variable":
            try
            {
              if(typeof _target === 'string')
              {
                let _global = (typeof window !== 'undefined'?window:(typeof global !== 'undefined'?global:null));
                if(_global != null)
                {
                  user_object = this._getDataValue(_global,_target,null);
                }
                else
                {
                  throw 'auth.method[variable].target cannot find a global (no window or global var)!';
                }
              }
              else if(typeof _target === 'object')
              {
                user_object=_target;
              }

              if(typeof user_object === 'object' && user_object!=null)
              {
                if(!('isConnectionTokenValid' in user_object) || typeof user_object.isConnectionTokenValid !== 'function')
                {
                  throw "Missing isConnectionTokenValid in user_object";
                }
                if(!('getConnectionToken' in user_object) || typeof user_object.getConnectionToken !== 'function')
                {
                  throw "Missing getConnectionToken in user_object";
                }
              }
            }
            catch(ex)
            {
              throw {code:'400', message: "Error processing auth.method[variable]: "+ex,_target};
            }
            break;
          case "cookie":
            user_object={};
            user_object.isConnectionTokenValid=function(){return true};
            user_object.getConnectionToken=function(){return _this._getCookie(auth.target)};
            break;
          case "target":
            user_object={};
            user_object.isConnectionTokenValid=function(){return true};
            user_object.getConnectionToken=function(){return auth.target};
            break;
          default:
            user_token=false;
            _this._log('debug','connections['+alias+'].fetch','Unknown auth.method',auth.hook);
            break;
        }
      }

      url=(url.endsWith('/')?url:url+'/');

      this.connections[alias]={};
      this.connections[alias].dataset={};
      this.connections[alias].fetch = async function(query,headers)
      {
        let result={code:'500', message: 'Unknown error'};
        try
        {
          for(let aheaders in headers)
          {
            options.header[aheaders]=headers[aheaders];
          }

          if(user_object && typeof user_object === 'object')
          {
            let is_logged_in = false;
            if(('isConnectionTokenValid' in user_object))
            {
              if(await user_object.isConnectionTokenValid(alias,require_role))
              {
                is_logged_in=true;
                if(('getConnectionToken' in user_object) && (typeof user_object.getConnectionToken === 'function'))
                {
                  user_token = user_object.getConnectionToken(alias);
                }
              }
            }
            if(!is_logged_in)
            {
              throw {code:'401', message: 'You need to be a '+(typeof require_role === 'string'?require_role:'user')+' to access this resource'};
            }
          }

          if('login_only' in auth && auth.login_only == 'yes')
          {
            if(user_token && typeof user_token === 'string' && user_token.length>0)
            {
              if('Authorization' in _options)
              {
                options['Authorization'].replace('{user_token}',user_token);
              }
              else
              {
                url.replace('{user_token}',user_token);
              }
            }
            else
            {
              throw {code:'401', message: 'You need to be a '+(typeof require_role === 'string'?require_role:'user')+' to access this resource (token missing)'};
            }
          }

          _this._log('debug','connections['+alias+'].fetch','Fetching',url+query,options);
          result = await fetch(url+query,options);
          if(('login_only' in auth && auth.login_only == 'yes') && ('try_login_on_401' in auth && auth.try_login_on_401 == 'yes') && result.code==401)
          {
            _this._log('debug','get','1st try 401-ed, trying again...');
            if(user_object && typeof user_object === 'object')
            {
              if(('renewSession' in user_object))
              {
                await user_object.renewSession();
              }
            }
            return _this.connections[alias].fetch(query,headers);
          }
        }
        catch(ex)
        {
          if(typeof ex === 'object' && 'code' in ex)
          {
            result=ex;
          }
          else
          {
            result={'code':500,'message':ex};
          }
        }
        return result;
      }

      this._log('debug','addConnection','Alias: '+alias+' connection added.');
      return true;
    }
    else
    {
      this._log('debug','addConnection','Alias: '+alias+' connection already exists. Skipping');
    }
    return false;
  }

  async _fetchAsync(method,target,query,allow_offline=false,retry=true)
  {
    let result={};
    result.code==500;
    result.status=='fetch-failed';
    let options = {
      method: method
    };

    try
    {
      let is_offline = await this._helpers.run('networking','isOfflineAsync',[],false);
      if(is_offline)
      {
        if(!allow_offline)
        {
          throw {code: '503', message: 'Offline without allow_offline',allow_offline};
        }
      }

      target=(target.endsWith('/')?target.substring(0,target.length-1):target);
      query=(target.startsWith('/')?query.substring(0,query.length-1):query);

      let _result = {};
      if(target.startsWith('http://') || target.startsWith('https://'))
      {
        _result = await fetch(target+'/'+query,options);
      }
      else
      {
        if(target in this.connections)
        {
          _result = await this.connections[target].fetch(query,options);
        }
        else
        {
          throw 'Unknown target "'+target+'"';
        }
      }

      if('status' in _result)
      {
        result.code=_result.status;
      }
      if('statusText' in _result)
      {
        result.message=_result.statusText;
      }
      if('headers' in _result)
      {
        if(_result.headers.get('content-type').includes('/json;'))
        {
          result.data= await _result.json();
          if(typeof result.data === 'object' && result.data!=null && 'code' in result.data)
          {
            result=result.data;
          }
        }
        else
        {
          result.data= await _result.text();
        }
      }
      else
      {
        result=_result;
      }
    }
    catch(ex)
    {
      result.message=ex;
    }

    return result;
  }

  async headAsync(target,query,allow_offline=false,retry=true)
  {
    let _this = this;
    return new Promise(function (resolve, reject) {

      let request = new XMLHttpRequest();
      request.open("HEAD",_this.url+'/'+target+'/'+query , true);
      request.setRequestHeader('Authorization','Bearer '+_this.user.token);
      request.onload = () => {
        if (request.status == 201 || request.status == 200) {
            resolve(true);
        } else {
            reject(false);
        }
      };
      request.onerror = function () {
          reject(false);
      };
      request.send();
    })
    .then(function(response) {
      return response;
    })
    .catch(function(err) {
       return err;
    });
  }

  async getRawRequestClientAsync(target,query,allow_offline=false,retry=true)
  {
    let _this = this;
    let request = {};
    request.client=new XMLHttpRequest();
    request.client.open("GET",this.url+'/'+target+'/'+query , true);
    request.client.setRequestHeader('Authorization','Bearer '+this.user.token);

    request.responseType = function(value){
      request.client.responseType=value;
    };

    request.onload = function(function__onload){
      request.client.onload  = () => {
        if (request.client.status == 200 || request.client.status == 201) {
          if(typeof function__onload == 'function')
          {
            return function__onload(request.client.response)
          }
          else
          {
            return request.client.response;
          }
        }
        else
        {
          _this._log('error','getArraybuffer.onload',request.client.response);
        }
      };
    }
    request.onerror = function(function__onerror){
      request.client.onerror  = () => {
        if (request.client.status >= 200 && request.client.status < 300) {
          if(typeof function__onerror == 'function')
          {
            return function__onerror(request.client.response)
          }
        }
        else
        {
          _this._log('error','getArraybuffer.onerror',request.client.response);
        }
      };
    }
    request.send = function(){
      request.client.send();
    }
    return request;
  }

  async getDatasetAsync(target,query,allow_offline=false,retry=true)
  {
    return this.getAsync(target,query,allow_offline,retry);
  }

  async getAsync(target,query='',allow_offline=false,retry=true)
  {
    let result = false;
    let _this = this;
    let log_subject = target+'/'+query;
    try
    {
      let _target_hash=false;
      if(typeof query === 'string')
      {
        _target_hash = this._processHash(query,{},'object');
      }

      this._log('debug','getAsync',log_subject,{'target':target,'query':query});

      let dataset_settings=target.substring(target.indexOf('|')+1);
      target=target.substring(0,target.indexOf('|'));

      if(dataset_settings.includes('+dataset::'))
      {
        let _dataset_settings={};
        _dataset_settings.mode='set';
        _dataset_settings.pipe=dataset_settings.substring(10);
        dataset_settings=_dataset_settings;
      }
      else if(dataset_settings.includes('dataset::'))
      {
        let _dataset_settings={};
        _dataset_settings.mode='get';
        _dataset_settings.pipe=dataset_settings.substring(9);
        dataset_settings=_dataset_settings;
      }
      else
      {
        dataset_settings=false;
      }

      if(dataset_settings && typeof dataset_settings === 'object' && 'mode' in dataset_settings && 'pipe' in dataset_settings)
      {
        let _pipe  = dataset_settings.pipe.split('@');
        if(_pipe.length>1)
        {
          let dataset_settings_key = _pipe.shift();
          dataset_settings.key = dataset_settings_key.substring(0,dataset_settings_key.indexOf('?'));
          dataset_settings.params=this._processQuery(dataset_settings_key,{},'object');
        }
        else
        {
          dataset_settings.key=dataset_settings.pipe;
          dataset_settings.params={};
        }

        if(typeof dataset_settings.params === 'object' && dataset_settings.params!=null)
        {
          if(!('include_filter' in dataset_settings.params))
          {
            dataset_settings.params.include_filter='no';
          }
        }
      }

      try
      {
        if(dataset_settings && typeof dataset_settings === 'object' && 'mode' in dataset_settings && dataset_settings.mode=='get' && 'key' in dataset_settings && dataset_settings.key.length>0)
        {
          result = await (async function(retry,delay){
            let return_error = {code:404, message: 'Dataset "'+dataset_settings.key+' does not exist'};
            let timeout_mode=false;
            let retry_left=retry;
            if(_this._helpers.has('tools','delaySecAsync',true))
            {
              timeout_mode=true;
            }
            let function__checkDatasetAvailable = async function()
            {
              retry_left--;
              if(_this.dataset[dataset_settings.key])
              {
                _this._log('debug','getAsync',log_subject+'->function__checkDatasetAvailable - Found dataset['+dataset_settings.key+']');
                return JSON.parse(JSON.stringify(_this.dataset[dataset_settings.key]));
              }
              else
              {
                if(timeout_mode)
                {
                  if(retry_left>0)
                  {
                    _this._log('debug','getAsync',log_subject+'->function__checkDatasetAvailable - Not found dataset['+dataset_settings.key+']... gonna await',{'retry':retry,'retry_left':retry_left, 'delay':delay});
                    await _this._helpers.run('tools','delaySecAsync',[delay]);
                    return await function__checkDatasetAvailable();
                  }
                  else
                  {
                    return_error = {code:404, message: 'Dataset "'+dataset_settings.key+' Not found, timed-out after "'+retry+'" attempts...'};
                  }
                }
                else
                {
                  return_error = {code:404, message: 'Dataset "'+dataset_settings.key+' Not found, retry not supported!'};
                }
              }
              _this._log('error','getAsync',log_subject+'->function__checkDatasetAvailable - Not found dataset['+dataset_settings.key+'] ... returning 404',{'return_error':return_error,'retry':retry,'retry_left':retry_left, 'delay':delay});
              return return_error;
            }
            return await function__checkDatasetAvailable();
          })(this._getSetting('dataset-retry',10),this._getSetting('dataset-polldelay',10));
        }
        else if(target)
        {
          if(_this._helpers.has('tools','delaySecAsync',true))
          {
            //await _this._helpers.run('tools','delaySecAsync',[60]);
          }
          result = await this._fetchAsync('get',target,query);
          this._log('debug','getAsync',log_subject+':result',result);
        }
        else
        {
          throw 'No target or dataset';
        }
      }
      catch(ex)
      {
        result = ex;
        this._log('error','getAsync',log_subject,ex);
      }

      if(typeof result === 'object' && result !== null && ('code' in result))
      {
        if(result.code==401)
        {
            //await this.user.run_login_redirect('change_layout');
            throw {code:'401', message: 'Not logged in and login refresh failed!'};
        }
        else if(result.code>300)
        {
          throw {code: result.code, message: result.message,data:{'result':result,'query':query,'target':target}};
        }
        else
        {
          if(!('state' in result))
          {
            result.state='success';
          }
          // Set dataset
          if(typeof result === 'object' && result!==null)
          {
            let _processDataMode = 'ommit';
            if(dataset_settings && typeof dataset_settings === 'object' && 'mode' in dataset_settings && dataset_settings.mode=='set')
            {
              if(dataset_settings.params.include_filter=='yes')
              {
                this.dataset[dataset_settings.key]=JSON.parse(JSON.stringify(result));
              }
              else
              {
                this.dataset[dataset_settings.key]=result;
              }
               this._log('debug','getAsync',log_subject+': Setting dataset['+dataset_settings.key+']',this.dataset[dataset_settings.key]);
            }

            if(typeof _target_hash === 'object' && Object.keys(_target_hash).length>0)
            {
              this._log('debug','getAsync',log_subject+': Filtering results for '+target+'/'+query+'',[result.data,_target_hash, _processDataMode]);
              if(('data' in result) && typeof result.data === 'object')
              {
                result.data=this._processData(result.data,_target_hash, _processDataMode);
              }
            }
          }

          return result;
        }
      }
      throw 'result not an object or not correctly formatted';
    }
    catch(ex)
    {
      let error_result = {code:500,message:ex,'debug_result':result};
      if(typeof ex === 'object' && ex !== null)
      {
        if('code' in ex)
        {
          error_result.code = ex.code;
        }
        if('message' in ex)
        {
          error_result.message = ex.message;
        }
        if('data' in ex)
        {
          error_result.data = ex.data;
        }
        error_result.ex = ex;
      }
      this._log('error','getAsync','Fatal error',ex);
      return error_result;
    }
  }


}


